/* ===================================================
   JF Sibling Prices — keep the current product's sibling
   button price in sync with the selected variant.
   Other sibling buttons (different products) stay on
   their first-available variant.
   Loaded on every product page.
   =================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateCurrentSiblingPrice(variant) {
    if (!variant) return;

    var checkedLabel = document.querySelector('.variant__button-label.checked');
    if (!checkedLabel) return;

    var priceWrapper = checkedLabel.querySelector('.jf-sibling-price');
    if (!priceWrapper) return;

    var currentSpan = priceWrapper.querySelector('.jf-sibling-price__current');
    var compareSpan = priceWrapper.querySelector('.jf-sibling-price__compare');

    var price = variant.price;
    var compare = variant.compare_at_price;

    if (currentSpan) currentSpan.textContent = formatMoney(price);

    if (compare && compare > price) {
      if (compareSpan) {
        compareSpan.textContent = formatMoney(compare);
      } else {
        var newCompare = document.createElement('span');
        newCompare.className = 'jf-sibling-price__compare';
        newCompare.textContent = formatMoney(compare);
        if (currentSpan) {
          priceWrapper.insertBefore(newCompare, currentSpan);
        } else {
          priceWrapper.appendChild(newCompare);
        }
      }
    } else if (compareSpan) {
      compareSpan.remove();
    }
  }

  function onVariantChange(e) {
    var variant = e.detail && e.detail.variant;
    updateCurrentSiblingPrice(variant);
  }

  document.addEventListener('variant:change', onVariantChange);
})();
